import cashBookInstance from '../../cashBook/instance'

export const getCashBookRecordsZIPFile = (dateFrom, dateTo) => {
	return cashBookInstance.get('/cash-book/records/zip?'
		+ (dateFrom ? 'dateFrom=' + dateFrom : '')
		+ (dateTo ? '&dateTo=' + dateTo : ''), {responseType: 'arraybuffer'})
}
